export const headers = [
	{
		id: 'id',
		label: 'ID',
		hidden: true,
		width: '150px',
	},
	{
		id: 'employeeId',
		label: '',
		width: '0',
		hidden: true,
	},
	{
		id: 'name',
		label: 'Nombre',
		width: '260px',
		ellipsis: true,
		showMore: true,
	},
	{
		id: 'position',
		label: 'Puesto',
		width: '200px',
	},
	{
		id: 'riskLevel',
		label: 'Nivel de riesgo',
		width: '180px',
	},
	{
		id: 'riskGroup',
		label: 'Grupo de riesgo',
		width: '188px',
	},
];

export const RiskLevelOptions = [
	{
		id: 'low',
		name: 'Bajo',
	},
	{
		id: 'medium',
		name: 'Medio',
	},
	{
		id: 'high',
		name: 'Alto',
	},
];

export const GROUPS = {
	Cardiovascular: 'Presión arterial',
	Dislipidemias: 'Niveles de Colesterol',
	Ergonomía: 'Referencia',
	reference: 'Referencia',
	'Diabetes Mellitus': 'Niveles de glucosa',
	'Sobrepeso/Obesidad': 'IMC',
	'Salud Mental (Burn-Out)': 'Referencia',
} as const;
